<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><i class="fa fa-envelope me-2"></i> Add Message</h4>
      </div>
      <div class="modal-body">

        <div class="mb-3">
          <label class="form-label">Predefined (optional)</label>
          <select class="form-select" [(ngModel)]="selectedPredefinedId" (ngModelChange)="onPredefinedChange()">
            <option [ngValue]="0">— None —</option>
            @for (p of predefinedList; track p.newsPredefinedId) {
              <option [ngValue]="p.newsPredefinedId">{{ p.name }}</option>
            }
          </select>
        </div>

        <div class="mb-3">
          <label class="form-label">Title</label>
          <input type="text" class="form-control" [(ngModel)]="title" (ngModelChange)="onFieldChanged()" placeholder="Title" />
        </div>

        <div class="mb-3">
          <label class="form-label">Summary</label>
          <textarea class="form-control" [(ngModel)]="summary" (ngModelChange)="onFieldChanged()" rows="2" placeholder="Summary"></textarea>
        </div>

        <div class="mb-3">
          <label class="form-label">Content</label>
          <textarea class="form-control" [(ngModel)]="content" (ngModelChange)="onFieldChanged()" rows="4" placeholder="Content"></textarea>
        </div>

        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" [(ngModel)]="isRate" id="isRateUserAdd">
          <label class="form-check-label" for="isRateUserAdd">Rate</label>
        </div>

        <hr/>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <strong>Rewards</strong>
          <button class="btn btn-sm btn-primary" type="button" (click)="addRewardRow()">
            <i class="fa fa-plus"></i> Add Reward
          </button>
        </div>

        @if (rewards.length === 0) {
          <p class="text-muted small">No rewards.</p>
        } @else {
          <table class="table table-sm">
            <thead class="thead-light">
              <tr>
                <th>Currency Type</th>
                <th>Quantity</th>
                <th>Ticket Cost</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (reward of rewards; track $index; let i = $index) {
                <tr>
                  <td>
                    <select class="form-select form-select-sm" [(ngModel)]="reward.currencyType">
                      @for (ct of currencyTypes; track ct[1]) {
                        <option [ngValue]="ct[1]">{{ ct[0] }}</option>
                      }
                    </select>
                  </td>
                  <td><input type="number" class="form-control form-control-sm" [(ngModel)]="reward.currencyQuantity" min="0" /></td>
                  <td><input type="number" class="form-control form-control-sm" [(ngModel)]="reward.currencyTicketCost" min="0" /></td>
                  <td>
                    <button class="btn btn-sm btn-danger" type="button" (click)="removeRewardRow(i)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.hide()" [disabled]="isLoading">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="isLoading">
          @if (isLoading) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Save
        </button>
      </div>
    </div>
  </div>
</div>
